var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBible = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 16 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 0h13v16H3a1 1 0 0 0 0 2h13v2H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 2a1 1 0 0 0-1 1v11.19A2.8 2.8 0 0 1 3 14h11V2Zm4 4V4a1 1 0 0 1 2 0v2h2a1 1 0 0 1 0 2H9v4a1 1 0 0 1-2 0V8H5a1 1 0 0 1 0-2Z",
  className: "icon-bible_svg__cls-1"
})));
export default SvgIconBible;